utaCustomBelts = function($){
  //$('head').append('<style>.cpb-category-color {display: none;}.right.line-one.text.side-1-line-1.side-1 {display: none;}</style>');
  function init() {
    if ($('.cpb-panel-wrapper').length < 1) {
      requestAnimationFrame(init);
    } else {
      var interval = window.setInterval(()=>{
     	 $('.option-type-color .cpb-option-type-color-bg').not('.cpb-active .cpb-option-type-color-bg').click();
      console.log($('.cpb-active .cpb-option-type-color-bg').length);
      if($('.cpb-active .cpb-option-type-color-bg').length > 0){window.clearInterval(interval);}
                                        },500);
      $('.cpb-option-type-color-bg').click();
    }
  }
	init();
}

gtmaCustomBelts = function($){
  //$('head').append('<style>.cpb-category-color {display: none;}.right.line-one.text.side-1-line-1.side-1 {display: none;}</style>');
  function init() {
    if ($('.cpb-panel-wrapper').length < 1) {
      requestAnimationFrame(init);
    } else {
      var interval = window.setInterval(()=>{
     	 $('.option-type-color .cpb-option-type-color-bg').not('.cpb-active .cpb-option-type-color-bg').click();
      console.log($('.cpb-active .cpb-option-type-color-bg').length);
      if($('.cpb-active .cpb-option-type-color-bg').length > 0){window.clearInterval(interval);}
                                        },500);
      $('.cpb-option-type-color-bg').click();
    }
  }
	init();
}
initUtaCustomBelts = function() {
  if (typeof jQuery == 'function') {
    utaCustomBelts(jQuery);
  } else {
    requestAnimationFrame(initUtaCustomBelts);
  }
};

initGtmaCustomBelts = function() {
  if (typeof jQuery == 'function') {
    gtmaCustomBelts(jQuery);
  } else {
    requestAnimationFrame(initGtmaCustomBelts);
  }
};

window.subdomain = /[a-zA-Z0-9-_]+/.exec(/:\/\/([^\/]+)/.exec(window.location.href)[1])[0];
		console.log(subdomain);
var image = document.querySelector('.site-header__logo-link img');

//Identify Subdomain and set logo and settings
if (subdomain != 'sparringsports' && subdomain != 'sparring-sports'){
  //document.onreadystatechange = () => {
  //if (document.readyState === 'interactive') {
          switch(subdomain){
            case 'uta':
              var association = 'UTA';
              //var logo = '//cdn.shopify.com/s/files/1/0415/0663/5934/files/uta_480x480.png?v=1633708954';
              var logo = '//cdn.shopify.com/s/files/1/0415/0663/5934/files/Logo-UTAblack-394x394_20240111.png?v=1705004274'
              initUtaCustomBelts();
              break;
            case 'mata':
              var association = 'MATA';
              var logo = '//cdn.shopify.com/s/files/1/0415/0663/5934/files/subdomain_mata_600x210_118f05a6-afc8-491b-b286-82e2976f0291.png?v=1692220267';
              //initUtaCustomBelts();
              break;  
            case 'gtma':
              var association = 'GTMA';
              var logo = '//cdn.shopify.com/s/files/1/0415/0663/5934/files/redpatch_250x.png?v=1620997448';
              initGtmaCustomBelts();
              break;
            //adding this for testing purposes
            case 'sample':
              var association = 'SAMPLE';
              var logo = '//cdn.shopify.com/s/files/1/0415/0663/5934/files/Sparring_Sports_-_1_000x500_c9c648a1-e00c-488d-afff-114809dcf973.png?v=1630561680';
              //initUtaCustomBelts();
              break;  
            case 'ta':
              var association = 'TA';
              var logo = '//cdn.shopify.com/s/files/1/0415/0663/5934/files/TA_Text.png?v=1706121877';
              //initUtaCustomBelts();
              break;  
            default:
              var association = 'Sparring Sports';
              var logo = '//cdn.shopify.com/s/files/1/0415/0663/5934/files/redpatch_250x.png?v=1620997448';
              break;
          }
          
    image.setAttribute('src', logo);
    image.setAttribute('srcset', '');
    image.setAttribute('alt', association);
	if(association === 'UTA'){
      	document.querySelectorAll('a[href*="custom-belt"]').forEach((e)=>{
          //check if custom belt is not pointing to UTA belt page
          //if not, update url to point to UTA custom belts page
          if(e.getAttribute("href") !== '/products/custom-belt-uta'){
            e.setAttribute("href", "/products/custom-belt-uta");           
            //e.parentNode.remove();
          }
        });
    } else if (association === 'GTMA') {

      //Loop through all href and replace the custom pages specific for GTMA
      document.querySelectorAll('a[href]').forEach((e)=>{        
          //Point to GTMA custom blackbelt page
          if(e.getAttribute("href") == '/products/custom-belts-sparring'){
            //Update with new link
            e.setAttribute("href", "/products/custom-belts-gtma");           
          }
        
          //Point to GTMA uniform and sparring collection
          if(e.getAttribute("href") == '/collections/uniforms-and-sparring-gear-1'){
            //Update with new link
            e.setAttribute("href", "/collections/gtma-uniforms-and-sparring-gear");           
          }
          
          //Point to GTMA sparring collection
          if(e.getAttribute("href") == '/collections/sparring-gear-1'){
            //Update with new link
            e.setAttribute("href", "/collections/gtma-sparring-gear");           
          }

          //Point to GTMA custom product collection
          if(e.getAttribute("href") == '/collections/custom-products-1'){
            //Update with new link
            e.setAttribute("href", "/collections/gtma-custom-products");           
          }
        });
      } else if (association === 'TA') {
      document.querySelectorAll('a[href]').forEach((e)=>{
          //Point to GTMA uniform and sparring collection
          if(e.getAttribute("href") == '/collections/custom-products-1'){
            //Update with new link
            e.setAttribute("href", "/collections/ta-custom-products");           
          }
        });
      
    }else{
      	document.querySelectorAll('[href*="custom-belt"]').forEach((e)=>{
          //check if custom belt is not pointing to standard custom black belts page
          //if not, update url to point tostandard custom black belts page
          if(e.getAttribute("href") !== '/products/custom-belts-sparring'){
              e.setAttribute("href", "/products/custom-belts-sparring");    
              //e.parentNode.remove();
          }
        });
      }
  	

    window.onload = function() {
		var $ = jQuery
        var q = 'body';
        if(window.location.href.includes('about-us')){
        	q = '#shopify-section-footer';
        }
          $(q).find('*:not(:has(*))').filter(':contains("Sparring Sports")').each(function(){
            var txt = $(this).text();
            $(this).text(txt.replace('Sparring Sports', association));
          });
      $('.site-footer__list-item a').filter(':contains("About Us")').text('About Sparring Sports');
      $('h1.small--text-center').filter(':contains("About Us")').text('About Sparring Sports');
      
    }.bind(association);
    //}
  //}
}else{
  document.querySelectorAll('a[href*="custom-belt"]').forEach((e)=>{
    if(e.getAttribute("href") !== '/products/custom-belts-sparring' && !e.parentNode.parentNode.classList.contains('cart__row')){
        e.parentNode.remove();//<----- this in
    }
  });
}
image.classList.add('ready');
